'use client';
import React, { useState } from 'react';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

export default function AccountSettings() {
  const [notifications, setNotifications] = useState(true);
  const [emailOffers, setEmailOffers] = useState(true);
  const [locationServices, setLocationServices] = useState(false);
  const [biometric, setBiometric] = useState(true);

  const toggles = [
    { id: 'notif', label: 'Anlık Bildirimler', desc: 'Sipariş güncellemeleri ve teklifler', value: notifications, onChange: setNotifications },
    { id: 'email', label: 'E-posta Teklifleri', desc: 'Haftalık kampanya ve yenilikler', value: emailOffers, onChange: setEmailOffers },
    { id: 'location', label: 'Konum Servisleri', desc: 'Yakındaki mağazaları bul', value: locationServices, onChange: setLocationServices },
    { id: 'biometric', label: 'Biyometrik Giriş', desc: 'Parmak izi veya yüz tanıma', value: biometric, onChange: setBiometric },
  ];

  const links = [
    { id: 'link-payment', label: 'Ödeme Yöntemleri', icon: 'CreditCardIcon', href: '/mobile-payment' },
    { id: 'link-privacy', label: 'Gizlilik Politikası', icon: 'ShieldCheckIcon', href: '#' },
    { id: 'link-help', label: 'Yardım Merkezi', icon: 'QuestionMarkCircleIcon', href: '#' },
    { id: 'link-terms', label: 'Kullanım Koşulları', icon: 'DocumentTextIcon', href: '#' },
  ];

  return (
    <div className="space-y-4">
      {/* Toggles */}
      <div className="bg-card rounded-2xl card-shadow overflow-hidden">
        <p className="text-foreground font-bold text-sm px-4 py-3 border-b border-border">Bildirim Ayarları</p>
        {toggles.map((t, idx) => (
          <div
            key={t.id}
            className={`flex items-center justify-between px-4 py-3 ${idx < toggles.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div>
              <p className="text-foreground font-semibold text-sm">{t.label}</p>
              <p className="text-muted-foreground text-xs">{t.desc}</p>
            </div>
            <button
              onClick={() => {
                t.onChange(!t.value);
                toast.success(`${t.label} ${!t.value ? 'açıldı' : 'kapatıldı'}`);
              }}
              className={`w-12 h-6 rounded-full transition-all duration-200 relative flex-shrink-0 ${t.value ? 'bg-primary' : 'bg-muted'}`}
            >
              <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-all duration-200 ${t.value ? 'left-6' : 'left-0.5'}`} />
            </button>
          </div>
        ))}
      </div>

      {/* Links */}
      <div className="bg-card rounded-2xl card-shadow overflow-hidden">
        <p className="text-foreground font-bold text-sm px-4 py-3 border-b border-border">Hesap</p>
        {links.map((link, idx) => (
          <Link
            key={link.id}
            href={link.href}
            className={`flex items-center gap-3 px-4 py-3 hover:bg-muted/50 transition-colors ${idx < links.length - 1 ? 'border-b border-border' : ''}`}
          >
            <Icon name={link.icon as any} size={18} className="text-muted-foreground" />
            <span className="text-foreground text-sm font-medium flex-1">{link.label}</span>
            <Icon name="ChevronRightIcon" size={16} className="text-muted-foreground" />
          </Link>
        ))}
      </div>

      {/* Logout */}
      <button
        onClick={() => toast.error('Çıkış yapıldı', { description: 'Güle güle, Ayşe!' })}
        className="w-full bg-red-50 text-red-600 font-bold py-4 rounded-2xl flex items-center justify-center gap-2 hover:bg-red-100 transition-colors active:scale-[0.98] border border-red-200"
      >
        <Icon name="ArrowRightOnRectangleIcon" size={18} className="text-red-600" />
        Çıkış Yap
      </button>

      <p className="text-center text-muted-foreground text-xs pb-2">
        Gloria Jean's Türkiye v2.14.0 · Üye: Tem 2022
      </p>
    </div>
  );
}